import { useEffect, useState } from 'react'
import { useCQuery, invalidateQuery } from '../../../Services/QueryCache'
import { FC } from '../../../Services/FeathersClient'

export const useTipoServizio = (tipoServizioId) => {
  const [tipoServizio, setTipoServizio] = useState()
  const { data, isSuccess } = useCQuery(['tipoServizio', tipoServizioId])

  useEffect(() => {
    isSuccess && setTipoServizio(data)
  }, [isSuccess, data])

  const setTipoServizioProp = (prop, value) =>
    setTipoServizio({ ...tipoServizio, [prop]: value })

  return [tipoServizio, setTipoServizioProp, isSuccess]
}

export const saveTipoServizio = async (tipoServizio) => {
  if (tipoServizio.id === 'new') {
    delete tipoServizio.id
    try {
      const res = await FC.service('tipiServizi').create({ ...tipoServizio })
      invalidateQuery(['tipoServizio', 'tipiServizi'])
      window.growl.show({ severity: 'success', summary: 'Success', detail: 'Salvataggio effettuato' })
      return res
    } catch (e) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore Salvataggio' })
      return false
    }
  }
  try {
    const res = await FC.service('tipiServizi').patch(tipoServizio.id, tipoServizio)
    invalidateQuery(['tipoServizio', 'tipiServizi'])
    window.growl.show({ severity: 'success', summary: 'Success', detail: 'Salvataggio effettuato' })
    return res
  } catch (e) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore Salvataggio' })
    return false
  }
}

export const deleteService = async (tipoServizioId) => {
  const res = await FC.service('tipiServizi').remove(tipoServizioId)
  invalidateQuery(['tipoServizio', 'tipiServizi'])
  window.growl.show({ severity: 'success', summary: 'Success', detail: 'Eliminazione effettuata' })
  return res
}
